import React from 'react';
import PropTypes from 'prop-types';
import ListItem from './ListItem';

const List = ({ ...props }) => {
  const { benefits, type } = props;

  return (
    <React.Fragment>
      {Object.entries(benefits).length &&
        benefits[`${type.toLowerCase()}`].map((benefit, index) => (
          <ListItem
            key={index}
            title={benefit.title}
            description={benefit.description}
          />
        ))}
    </React.Fragment>
  );
};

List.propTypes = {
  benefits: PropTypes.object,
  type: PropTypes.string,
};

export default List;
